import { useState } from 'react';
import Modal from './Modal';

const useModal = ({ modalContent, title = null, dataName = null, hasFade = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const modal = isOpen ? (
    <Modal title={title} closeModal={closeModal} dataName={dataName} hasFade={hasFade}>
      {modalContent}
    </Modal>
  ) : null;

  return {
    modal,
    closeModal,
    openModal,
  };
};

export default useModal;
